import React from 'react'
import { Link } from 'react-router-dom'

import './index.less'

const NoFound = () =>(
 
  <main className = "errorPage">
    <div className = "img-bar">
      <img className = "img-status" src = {require('../../assets/404.svg')} alt = "403" />
    </div>
    <div className = "tip">
      <span className = "tip-status">
        404
      </span>
      <span className = "tip-text">
        抱歉，你访问的页面不存在
      </span>
      <Link to = "/home" className = "tip-btn">返回首页</Link>
    </div>
  </main>

)

export default NoFound